export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0041.d6867368.webp";